import KanjiService from './kanji';
import RecognitionService from './recognition';

export const kanjiService = new KanjiService();
export const recognitionService = new RecognitionService();

